module.exports = __webpack_public_path__ + "public/img/server-wechat13.8a7035a9.png";